// import React, {useEffect} from 'react';
// import arrowRight from "../assetes/chevron-back.svg";
// import arrowLeft from "../assetes/chevron-forward.svg";
// import {useDispatch, useSelector} from "react-redux";
// import { getAllAccident } from '../redux/apiCalls/accidentApiCall';
// function Pagination({pages, currentPage, setCurrentPage}) {
//     const generatedPage = [];
//     for (let i = 1; i <= pages; i++) {
//         generatedPage.push(i);
//     }
//     const dispatch = useDispatch();
//     const { accidents, numberOfAccidents} = useSelector(state => state.accident);
//     useEffect(() => {
//         dispatch(getAllAccident());
//     }, [dispatch]);
//     return (
//         <>
//                         <div className="flex justify-between mt-[15px]">
//                     <p className="text-[#525252] text-[14px] leading-[20px] font-[400]">
//                         Showing {accidents.users?.length} of {numberOfAccidents}
//                     </p>
//                     <div className="flex items-center justify-center p-[5px] mb-[20px] text-[#242424] mt-[10px]">
//                 <button
//                     disabled={currentPage === 1}
//                     onClick={() => setCurrentPage((current) => current - 1)}
//                     className="w-[39px] h-[39px] border-[1px] border-[#C9C9C9] flex items-center justify-center text-[18px] text-[#242424] cursor-pointer rounded-l-[6px] bg-[#FBFBFB]"
//                     >
//                         <img src={arrowRight} alt='arrow-icon'  size={15} />
//                 </button>
//                     {generatedPage.map((page) => (
//                     <div
//                     onClick={() => setCurrentPage(page)}
//                     key={page}
//                     className={`${currentPage === page ? "page pagi activePagi" : "page"} dark:bg-slate-800 dark:text-white`}
//                     >
//                     {page}
//                     </div>
//                 ))}
//                 <button
//                     disabled={currentPage === pages}
//                     onClick={() => setCurrentPage((current) => current + 1)}
//                     className="w-[39px] h-[39px] border-[1px] border-[#C9C9C9] flex items-center justify-center text-[18px] text-[#242424] cursor-pointer rounded-r-[6px] bg-[#FBFBFB]"
//                     >
//                         <img src={arrowLeft} alt="arrow-icon" size={15} />
//                 </button>
//                     </div>
//                 </div>
//         </>
//     )
// }

// export default Pagination;




// import React from "react";

// const Pagination = ({ totalPages, currentPage, onPageChange }) => {
//   const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

//   return (
//     <div className="flex gap-2 mt-4 justify-center">
//       <button
//         onClick={() => onPageChange(currentPage - 1)}
//         disabled={currentPage === 1}
//         className="px-3 py-1 bg-gray-200 border rounded disabled:opacity-50"
//       >
//         Previous
//       </button>

//       {pages.map((page) => (
//         <button
//           key={page}
//           onClick={() => onPageChange(page)}
//           className={`px-3 py-1 ${
//             currentPage === page
//               ? "bg-blue-500 text-white"
//               : "bg-gray-200 border"
//           } rounded`}
//         >
//           {page}
//         </button>
//       ))}

//       <button
//         onClick={() => onPageChange(currentPage + 1)}
//         disabled={currentPage === totalPages}
//         className="px-3 py-1 bg-gray-200 border rounded disabled:opacity-50"
//       >
//         Next
//       </button>
//     </div>
//   );
// };

// export default Pagination;




// import React, { useState } from "react";
// import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
// const Pagination = ({ totalPages, currentPage, onPageChange, data }) => {
//   const [visiblePages, setVisiblePages] = useState(() => {
//     const start = Math.max(currentPage - 2, 1);
//     const end = Math.min(currentPage + 2, totalPages);
//     return Array.from({ length: end - start + 1 }, (_, i) => start + i);
//   });

//   const goToPage = (page) => {
//     if (page < 1 || page > totalPages) return;

//     onPageChange(page);

//     setVisiblePages(() => {
//       const start = Math.max(page - 2, 1);
//       const end = Math.min(page + 2, totalPages);
//       return Array.from({ length: end - start + 1 }, (_, i) => start + i);
//     });
//   };

//   const isNextDisabled = () => {
//     // تحقق إذا كانت الصفحة الحالية هي الأخيرة أو أن الصفحة التالية لا تحتوي على بيانات
//     return currentPage === totalPages || (data && data.length === 0);
//   };

//   return (
//     <div className="flex justify-center items-center gap-2 mt-6">
//       {/* زر الرجوع */}
//       <button
//         onClick={() => goToPage(currentPage - 1)}
//         disabled={currentPage === 1}
//         className={`w-10 h-10 flex items-center justify-center rounded-lg border ${
//           currentPage === 1
//             ? "cursor-not-allowed bg-gray-200 text-gray-400 border-gray-300"
//             : "cursor-pointer bg-white text-gray-800 hover:bg-gray-100 border-gray-300"
//         }`}
//       >
//         <FaArrowLeft />
//       </button>

//       {/* الأزرار المرقمة */}
//       {visiblePages.map((page) => (
//         <button
//           key={page}
//           onClick={() => goToPage(page)}
//           className={`w-10 h-10 flex items-center justify-center rounded-lg border text-sm font-medium ${
//             page === currentPage
//               ? "bg-blue-500 text-white border-blue-500"
//               : "bg-white text-gray-800 border-gray-300 hover:bg-gray-100"
//           }`}
//         >
//           {page}
//         </button>
//       ))}

//       {/* زر التقدم */}
//       <button
//         onClick={() => goToPage(currentPage + 1)}
//         disabled={isNextDisabled()}
//         className={`w-10 h-10 flex items-center justify-center rounded-lg border ${
//           isNextDisabled()
//             ? "cursor-not-allowed bg-gray-200 text-gray-400 border-gray-300"
//             : "cursor-pointer bg-white text-gray-800 hover:bg-gray-100 border-gray-300"
//         }`}
//       >
//         <FaArrowRight />
//       </button>
//     </div>
//   );
// };
// export default Pagination



import React from 'react';

function Pagination({ currentPage, totalPages, onPageChange }) {
  return (
    <div className="flex justify-center mt-4">
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="px-4 py-2 mx-1 text-gray-500 bg-gray-200 rounded hover:bg-gray-300"
      >
        ❮
      </button>
      {[...Array(totalPages)].map((_, index) => (
        <button
          key={index}
          onClick={() => onPageChange(index + 1)}
          className={`px-4 py-2 mx-1 ${
            currentPage === index + 1 ? "text-white bg-blue-500" : "text-gray-500 bg-gray-200"
          } rounded hover:bg-gray-300`}
        >
          {index + 1}
        </button>
      ))}
      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="px-4 py-2 mx-1 text-gray-500 bg-gray-200 rounded hover:bg-gray-300"
      >
        ❯
      </button>
    </div>
  );
}

export default Pagination;